'use strict';

// eslint-disable-next-line no-undef
intellidealerAppCoreModule.config(function ($stateProvider) {
  $stateProvider.state(
    'public', {
      url: '/{library}/public/{company}/{division}',
      templateUrl: 'app/scripts/modules/core/views/public.html',
      abstract: true,
      controller: ['$scope', '$state', 'globalAlertService', 'shoppingCartService', 'dealershipConfiguration', 'multiMediaStreamingURLService', 'worldpayUrlService', function ($scope, $state, globalAlertService, shoppingCartService, dealershipConfiguration, multiMediaStreamingURLService, worldpayUrlService) {
        $scope.dealershipName = dealershipConfiguration.dealershipName;
        if (dealershipConfiguration.dealershipLogo) {
          $scope.dealershipLogo = multiMediaStreamingURLService.getMultiMediaStreamingPublicWebConfigURL(dealershipConfiguration.remoteServerPath + dealershipConfiguration.dealershipLogo, true);
        }
        $scope.alerts = globalAlertService.currentAlerts;
        if ($state.current.name.startsWith('public.parts') || $state.current.name.startsWith('public.shopping')) {
          if(!$state.params.cartId && !$state.params.catchACartId){
            // cartId / catchACartId come from the John Deere parts catalog integration.
            // loadShoppingCart here races with catalog parts loading on the backend — skip when those params are set.
            // On Worldpay return to checkout, the checkout controller reloads the cart after restoring pickup location.
            if (!($state.current.name.indexOf('checkout') >= 0 && worldpayUrlService.isActiveCheckoutReturn())) {
              shoppingCartService.loadShoppingCart();
            }
          }
        }
      }],
      resolve: {
        version: ['cdkAnalyticsService', function (cdkAnalyticsService) {
          return cdkAnalyticsService.setLibrary();
        }],
        userConfiguration: ['$stateParams', '$rootScope', 'loginResource', 'securityResource', '$state', '$q', 'publicModeService', 'cdkAnalyticsService', 'worldpayUrlService', 'version',
          function ($stateParams, $rootScope, loginResource, securityResource, $state, $q, publicModeService, cdkAnalyticsService, worldpayUrlService, version /*wait on this*/) {
            // Restore Worldpay cart ref/location before public re-login so session binds to the existing cart.
            worldpayUrlService.restoreCheckoutContext(true);
            return loginResource.post({
              library: $stateParams.library.toUpperCase(),
              company: $stateParams.company,
              division: $stateParams.division,
              system: 'MD',
              publicMode: true,
              cartReferenceNumber: publicModeService.getCartReferenceNumber() || worldpayUrlService.getStoredCartReference()
            }).$promise.then(function () {
              cdkAnalyticsService.setGlobalField('company', $stateParams.company);
              cdkAnalyticsService.setGlobalField('division', $stateParams.division);
              $rootScope.gadimension3 = $stateParams.company;
              $rootScope.gadimension4 = $stateParams.division;
              return securityResource.customerContactSecurity.get().$promise.catch(function (error) {
                if(error.data.type === "UNAVAILABLE") {
                  $state.go('login');  
                }
              });
            }).catch(function (error) {
              if (error.data.message == 'Feature not licensed.') {
                $state.go('publicBadStateLicense');
              } else {
                $state.go('publicBadState');
              }
              return $q.reject();
            });
          }],
        dealershipConfiguration: ['dealershipConfigurationService', '$stateParams', 'themeApplicationService', 'userConfiguration', function (dealershipConfigurationService, $stateParams, themeApplicationService, userConfiguration /*wait on this*/) {
          return dealershipConfigurationService($stateParams.library.toUpperCase()).then(function (value) {
            themeApplicationService(value.baseColor.symbol);
            return value;
          });
        }],
        language: ['$stateParams', 'languageService', 'userConfiguration', function ($stateParams, languageService, userConfiguration /*wait on this*/) {
          return languageService.populatePublic($stateParams.library.toUpperCase(), userConfiguration.screenLanguage);
        }],
        customizedMessages: ['$stateParams', 'customizedMessagesService', function ($stateParams, customizedMessagesService) {
          return customizedMessagesService.populatePublicMessages($stateParams.library.toUpperCase(), $stateParams.company, $stateParams.division);
        }],
        locations: ['locationService', 'userConfiguration', function (locationService, userConfiguration /*wait on this*/) {
          return locationService.populateAssignedLocations(true, "");
        }],
        googleAnalytics: ['$rootScope','cdkAnalyticsService', 'locationService', 'locations', function ($rootScope, cdkAnalyticsService, locationService, locations /*wait on this*/) {
          if (cdkAnalyticsService.isServiceAvailable !== false) {
            return cdkAnalyticsService.loadTrackingIds().then(function (response) {
              cdkAnalyticsService.setGlobalField('branch', locationService.getBusinessLocation());
              $rootScope.gadimension5 = locationService.getBusinessLocation();
              return response;
            });
          }
        }]
      }
    });
});
